import FeatureModal from '~/components/ui/FeatureModal';

const GlobalFeatureModal = () => {
  return <FeatureModal />;
};

export default GlobalFeatureModal;
